export function clone(obj) {
    const copy = {}
    for (var attr in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, attr)) copy[attr] = obj[attr]
    }
    return copy
}

export function defaults(obj, defaultObject) {
    obj = clone(obj || {})
    for (const k in defaultObject) {
        if (obj[k] === undefined) obj[k] = defaultObject[k]
    }
    return obj
}

export function insertAfter(refNode, nodeToInsert) {
    const parent = refNode.parentNode

    parent.appendChild(nodeToInsert)

}

export function insertBefore(refNode, nodeToInsert) {
    const parent = refNode.parentNode
    parent.insertBefore(nodeToInsert, refNode)
}

export function forEach(items, fn) {
    if (!items) return
    if (items.forEach) {
        items.forEach(fn)
    } else {
        for (let i = 0; i < items.length; i++) {
            fn(items[i], i, items)
        }
    }
}

export function debounce(ms, fn) {
    let timeout
    const debouncedFn = function () {
        clearTimeout(timeout)
        timeout = setTimeout(fn, ms)
    }
    return debouncedFn
}

export function loadJs(sourceUrl) {
    if (sourceUrl != null) {
        var tag = document.createElement('script');
        tag.src = sourceUrl;
        tag.type = "text/javascript";
        document.body.appendChild(tag);
    }
}

export function isDevice() {
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i.test(navigator.userAgent);
}

export function scrollParentToElement(parent) {
   if (parent == null) {
        return;
    }
    const element = document.querySelector('.' + parent.className + ' ul li.active');

    if (element != null) {
        parent.scrollTo({
            top: element.offsetTop,
            behavior: "smooth"
        });
    }


}
export function loadInlineScript(inlinescript) {
    // create JS library script element
    var script = document.createElement("script");
    script.innerText = inlinescript;
    document["body"].appendChild(script);
}
export async function loadScript(scriptPath) {
    // check list - if already loaded we can ignore
   if (loadedScripts[scriptPath] === false) {
        return new Promise(function (resolve, reject) {
            // wait a bit?
            setTimeout(function () {
                resolve();
            }, 1500);

        });
    }

    if (loadedScripts[scriptPath]) {
        // return 'empty' promise
        return new Promise(function (resolve, reject) {
            resolve();
        });
    }

    return new Promise(function (resolve, reject) {
        // create JS library script element
        var script = document.createElement("script");
        script.src = scriptPath;
        script.type = "text/javascript";


        // flag as loading/loaded
        loadedScripts[scriptPath] = false;

        // if the script returns okay, return resolve
        script.onload = function () {
            loadedScripts[scriptPath] = true;
            resolve(scriptPath);
        };

        // if it fails, return reject
        script.onerror = function () {
            reject(scriptPath);
        }
        // scripts will load at end of body
        document["body"].appendChild(script);
    });
}
// store list of what scripts we've loaded
const loadedScripts = [];
